<template>
  <div class="page_container content-box">
    <KnowledgeList />
  </div>
</template>

<script>
import KnowledgeList from './KnowledgeList.vue';

export default {
  components: {
    KnowledgeList,
  },
};
</script>

<style></style>
